import {useNormalizer, useDev} from '@sttedra_ui/framework';

import useHelpers from '@/composables/helpers';

import {useDateFormat, useEventListener} from '@vueuse/core';

const {getObjectFilled, getString, getDate} = useNormalizer();

const {stringToDateIso} = useHelpers();

// #region DATE

/**
 *
 * @param {*} data
 * @param {*} eventHelpers
 * @param {*} fieldID
 * @returns
 */
function onMountedFieldDate(
  fieldID = null,
  data = null,
  eventHelpers = {},
  properties = {
    tabIndex: 0,
  },
  checkCorrectBirthDate,
) {
  try {
    if (!getString(fieldID)) return;
    if (!getObjectFilled(eventHelpers)) return;

    const selectorInput = `.form__item--${fieldID.toLowerCase()} input`;
    const inputField = document.querySelector(selectorInput);

    if (!inputField) return;

    if (properties.tabIndex) {
      inputField.tabIndex = properties.tabIndex;
    }

    // Clone input field to remove event listeners
    const cloneInputField = inputField.cloneNode(true);
    inputField.parentNode.replaceChild(cloneInputField, inputField);

    cloneInputField.setAttribute('tabindex', properties.tabIndex || 0);
    cloneInputField.setAttribute('placeholder', 'Formato: DD/MM/YYYY');
    cloneInputField.setAttribute('aria-label', 'Fecha de nacimiento');
    cloneInputField.setAttribute('aria-required', 'true');
    cloneInputField.setAttribute('inputMode', 'manual');

    const selectorAfter = `.form__item--${fieldID.toLowerCase()}--icon`;
    const selectorBtn = `.form__item--${fieldID.toLowerCase()} .p-datepicker-trigger`;
    const btnField = document.querySelector(selectorBtn);
    const after = document.querySelector(selectorAfter);

    if (btnField) {
      btnField.tabIndex = properties.tabIndex;
    }

    if (after) {
      after.tabIndex = properties.tabIndex;
    }

    // add event listeners
    useEventListener(cloneInputField, 'change', async (event) => {
      onChangeFieldDate(event, eventHelpers, fieldID, checkCorrectBirthDate);
    });
  } catch (error) {
    useDev.error('[onMountedFieldDate]', error);
  }
}

/**
 *
 * @param {*} event
 * @param {*} eventHelpers
 */
function onChangeFieldDate(
  event,
  eventHelpers = {},
  fieldID,
  checkCorrectBirthDate = () => {},
) {
  try {
    const date = stringToDateIso(event.target.value);
    checkCorrectBirthDate(date);

    const selectorAfter = `.form__item__${fieldID.toLowerCase()}--icon`;
    const afterField = document.querySelector(selectorAfter);

    if (getDate(date) && date.toString() !== 'Invalid Date') {
      eventHelpers.changeFieldValue(fieldID, date);
      event.target.value = event.target.value.trim();
      if (!afterField) return;
      afterField.classList.remove('p-invalid');
    } else {
      event.target.value = '';
      eventHelpers.changeFieldValue(fieldID, null);
      eventHelpers.getV$()[fieldID].$validate();
      if (!afterField) return;
      afterField.classList.add('p-invalid');
    }
  } catch (error) {
    useDev.error('[onChangeFieldDate]', error);
  }
}

function onDateSelect(
  value,
  fieldID = null,
  eventHelpers = {},
  checkCorrectBirthDate = () => {},
) {
  const selectorInput = `.form__item--${fieldID.toLowerCase()} input`;
  const inputField = document.querySelector(selectorInput);
  checkCorrectBirthDate(value);

  if (!inputField) return;

  if (!getDate(value)) {
    inputField.value = '';
    eventHelpers.changeFieldValue(fieldID, null);
    return;
  }

  value.setHours(0, 0, 0, 0);
  inputField.value = useDateFormat(value, 'DD/MM/YYYY').value;
  eventHelpers.changeFieldValue(fieldID, value);
}

function onShow(fieldID = null, eventHelpers) {
  const selectorInput = `.form__item--${fieldID.toLowerCase()} input`;
  const inputField = document.querySelector(selectorInput);

  if (!inputField || !inputField.value) return;

  const date = stringToDateIso(inputField.value);
  if (getDate(date) && date.toString() !== 'Invalid Date') {
    eventHelpers.changeFieldValue(fieldID, date);
  } else {
    eventHelpers.getV$().validDateDNI.$validate();
  }
}
function onHide(fieldID = null) {
  const selectorInput = `.form__item--${fieldID.toLowerCase()} input`;
  const inputField = document.querySelector(selectorInput);
  if (!inputField) return;

  setTimeout(() => {
    inputField.focus();
  }, 10);
}
// #endregion

export {onMountedFieldDate, onDateSelect, onShow, onHide};
